// 自身のアカウント情報を常に保持する

import jwt from 'jsonwebtoken'
import API from '../../api'
import {callApiWithRefresh, timewait} from '../../api/util'

const state = {
    id: window.localStorage.getItem('account/id'),
    accessToken: window.localStorage.getItem('account/accessToken'),
    refreshToken: window.localStorage.getItem('account/refreshToken'),
    authenticated: (window.localStorage.getItem('account/authenticated'))? window.localStorage.getItem('account/authenticated').toLowerCase() === 'true' : false,
    name: ""
}

const getters = {
    initialized() {
        return !!state.id
    },
    authenticated(state) {
        return state.authenticated
    },
    accessToken(state) {
        return state.accessToken
    }
}

const mutations = {
    setUser(state, user) {
        if (user.id) {
            window.localStorage.setItem('account/id', user.id)
            state.id = user.id
        }
        if (user.accessToken) {
            window.localStorage.setItem('account/accessToken', user.accessToken)
            state.accessToken = user.accessToken
        }
        if (user.refreshToken) {
            window.localStorage.setItem('account/refreshToken', user.refreshToken)
            state.refreshToken = user.refreshToken
        }
        if (user.authenticated) {
            window.localStorage.setItem('account/authenticated', user.authenticated)
            state.authenticated = user.authenticated
        }
        if (user.name) {
            state.name = user.name
        }
    },
    removeUser(state) {
        state.id = null
        state.name = null
        state.accessToken = null
        state.refreshToken = null
        window.localStorage.clear()
    },
    logoutUser(state) {
        state.id = null
        state.name = null
        state.accessToken = null
        state.refreshToken = null
        window.localStorage.clear()
        window.localStorage.setItem('preferences/isWelcome', "false")

    },
    refreshToken(state, token) {
        window.localStorage.setItem('account/accessToken', token.access_token)
        state.accessToken = token.access_token
    }
}

const actions = {
    authorization(ctx, code) {
        return Promise.resolve()
        .then(() => {
            if (ctx.state.accessToken) {
                return callApiWithRefresh(
                    () => ctx.state.accessToken,
                    () => ctx.dispatch('_refreshToken'),
                    (token) => API.authorization(code, token)
                )
                .catch(e => {
                    if (e.message == `"user already exists"\n{"access_token":"","token_type":"Bearer","expires_in":0,"refresh_token":""}\n`)
                        return API.authorization(code)
                    else
                        return Promise.reject(e)
                })
            } else {
                return API.authorization(code)
            }
        })
            .then(user => {
            const decoded = jwt.decode(user.access_token)
            const userId = decoded.sub
            try {
                ctx.commit('setUser', {
                    verified: true,
                    id : userId,
                    name: "",
                    accessToken: user.access_token,
                    refreshToken: user.refresh_token,
                    authenticated: true
                })
            } catch(e) {
                return new Promise.reject(e)
            }
            return ctx.dispatch('getUser')
        })
    },
    registerUser(ctx) {
        return API.registerUser()
        .then(user => {
            try {
                ctx.commit('setUser', {
                    verified: false,
                    id: user.UserID,
                    name: user.Name,
                    accessToken: user.Token.access_token,
                    refreshToken: user.Token.refresh_token,
                    authenticated: false
                })
            } catch (e) {
                return new Promise.reject(e)
            }
            return ctx.dispatch('getUser')
        })
        .then(() => {
            return ctx.dispatch('groups/modifyGroup', {
                gId: Object.keys(ctx.rootState.groups.ownGroups)[0],
                name: ctx.rootState.preferences.locale === "ja" ? "無名のグループ" : "Unnamed Group"
            }, { root: true })
        })
        .then(() => ctx.dispatch('getUser'))
    },
    getUser(ctx) {
        return callApiWithRefresh(
            () => ctx.state.accessToken,
            () => ctx.dispatch('_refreshToken'),
            (token) => API.getUser(token)
        )
        .then(usr => {
            ctx.commit('setUser', {
                name: usr.Name
            })
            ctx.commit('groups/_init', {
                ownGroups: usr.OwnGroups ? usr.OwnGroups.reduce((p, c) => {
                    p[c.GroupID] = c.Name
                    return p
                }, {}) : {},
                joinedGroups: usr.JoinedGroups ? usr.JoinedGroups.reduce((p, c) => {
                    p[c.GroupID] = c.Name
                    return p
                }, {}) : {}
            }, {root: true})
        })
    },
    modifyUser(ctx, name) {
        return callApiWithRefresh(
            () => ctx.state.accessToken,
            () => ctx.dispatch('_refreshToken'),
            (token) => API.modifyUser(name, token)
        )
        .then(() => timewait(2000))
        .then(() => ctx.dispatch('getUser'))
    },
    deleteUser(ctx) {
        return callApiWithRefresh(
            () => ctx.state.accessToken,
            () => ctx.dispatch('_refreshToken'),
            (token) => API.deleteUser(token)
        )
        .then(() => timewait(2000))
        .then(() => ctx.commit('removeUser'))
    },
    logout_tmp(ctx) {
        ctx.commit('logoutUser')
    },
    logout(ctx) {
        ctx.commit('removeUser')
    },
    _refreshToken(ctx) {
        if (ctx.state.id != null && ctx.state.refreshToken != null) {
            return API.getUserToken(ctx.state.id, ctx.state.refreshToken)
            .then(token => {
                ctx.commit('setUser', {accessToken: token.access_token})
            })
        } else {
            return Promise.reject("not login")
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
